<template>
	<div>
		<img  class="imgtop" src="http://shandongtibohui.zsyflive.com/profile/xd/ruier/gongzhong/2020122310043322b664.jpg"/>
		
		<div class="colonn">
			<div style="height: 100px;"></div>
			<div class="roww">
				<div style="width: 50%;"></div>
				<div class="colonn">
					<div class="biaotiss">为客户提供<span style="color:brown;">一站式</span>国际化标准展览服务</div>
					<div style="color: #bb1b21;border-bottom:3px solid #bb1b21;">
						&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;
					</div>
					<div style="line-height: 35px; text-indent: 2em;">
						“瑞尔”英文“real”的谐音，真实、真诚、真正的意思也是公司立存之本。公司成立于2014年，从事国内大型展会主场，博物馆、纪念馆、科技馆、企业馆展厅策划、设计施工一体化、场馆运营专业化展览公司，可为客户提供一站式国际化标准展览服务。
					</div>
					<div style="line-height: 35px; text-indent: 2em;">
						    瑞尔会展本着精益求精、真诚服务的企业精神立足山东，服务全国。以其独特的发展理念，肩负引领行业发展的重要责任。
					</div>
				</div>
				<div style="width: 50%;"></div>
				<img style="width:40%;" src="http://shandongtibohui.zsyflive.com/profile/xd/ruier/gongzhong/202109231637235d07e6.jpg"/>
			</div>
			<div class="roww">
				<div style="width: 50%;"></div>
				<div class="colonn">
					<div class="biaotiss"><span style="color:brown;">资深</span>设计精英和<span style="color:brown;">高质量</span>施工团队</div>
					<div style="color: #bb1b21;border-bottom:3px solid #bb1b21;">
						&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;
					</div>
					<div style="line-height: 35px; text-indent: 2em;">
						瑞尔团队坚持以人为本，跨界整合的人才培养模式，每年组织创意团队不定期国外学习交流。通过与国内外设计机构的融合发展，培养和历练出一批资深设计精英和一批高质量施工团队。每年为数百家客户提供策划、设计、施工的工程面积在10多万平方米以上。
					</div>
				</div>
				<div style="width: 50%;"></div>
				
				<img style="width:40%;" src="http://shandongtibohui.zsyflive.com/profile/xd/ruier/gongzhong/20201224095626cd91f8.png"/>
			</div>
			<div class="roww">
				<div style="width: 35%;"></div>
				<div class="colonn" style="width: 100%;">
					<div class="biaotiss">给我们一方空间，还您<span style="color:brown;">精彩世界</span></div>
					<div style="color: #bb1b21;border-bottom:3px solid #bb1b21;">
						&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;
					</div>
					<div style="line-height: 35px; text-indent: 2em;">
						瑞尔使命：让世界了解你<br>
						
						瑞尔愿景：智能展馆领航者<br>
						
						瑞尔价值观：诚信 专业 创新 团结<br>
						
						瑞尔经营理念：精益求精、真诚服务<br>
						
						口号：给我们一方空间，还您精彩世界<br>
					</div>
				</div>
				<div style="width: 20%;"></div>
				
				<img style="width:40%;" src="http://shandongtibohui.zsyflive.com/profile/xd/ruier/gongzhong/20210923163741ff00b6.jpg"/>
			</div>
		</div>
		
		<img  src="http://shandongtibohui.zsyflive.com/profile/xd/ruier/gongzhong/20201223112623fb59ae.jpg" class="imgtop"/>
		<img  src="http://shandongtibohui.zsyflive.com/profile/xd/ruier/gongzhong/20201221090619fd8014.jpg" class="imgtop"/>
	</div>
</template>

<script>

	export default {
		name: 'ComponentName', // 组件的名称
		components: {
			
		},

		data() {
			return {
				
			}
		},

		props: {
			// 组件的属性
		},

		computed: {
			// 组件的计算属性
		},

		methods: {

		},

		mounted() {
			// 组件挂载后的操作
		},

	}
</script>

<style>
	@import url(about.css);
</style>